import React from 'react'
import {useTranslation} from '@modifi/plugin-i18n'
import {
  COMPANY_REGISTRATION_NUMBER,
  COMPANY_REGISTRATION_ISSUER,
  COMPANY_VAT_NUMBER,
  COMPANY_TAX_NUMBER,
  COMPANY_IMPORT_EXPORT_CODE,
  COMPANY_CIN_CODE,
  InputComponent,
  InputTooltipInfo,
} from '@modifi/plugin-onboarding'

import {FormInputComponentCol} from '../../../../../plugins/onboarding'
import {FormRow} from '../../../../../ui/form'

type RegistrationNumbersFormContentProps = {
  externalErrorMessages: Record<string, string>
}

const RegistrationNumbersFormContent: React.FC<RegistrationNumbersFormContentProps> = ({
  externalErrorMessages,
}) => {
  const {t} = useTranslation(['charon', 'plugin-forms'])

  return (
    <>
      <FormRow mb={56}>
        <FormInputComponentCol
          t={t}
          inputComponent={InputComponent}
          inputName={COMPANY_REGISTRATION_NUMBER}
          key={COMPANY_REGISTRATION_NUMBER}
          isValid={!externalErrorMessages[COMPANY_REGISTRATION_NUMBER]}
          errorMessage={externalErrorMessages[COMPANY_REGISTRATION_NUMBER]}
          inputProps={{
            labelAddition: <InputTooltipInfo inputName={COMPANY_REGISTRATION_NUMBER} t={t} />,
          }}
        />

        <FormInputComponentCol
          t={t}
          inputComponent={InputComponent}
          inputName={COMPANY_REGISTRATION_ISSUER}
          key={COMPANY_REGISTRATION_ISSUER}
          isValid={!externalErrorMessages[COMPANY_REGISTRATION_ISSUER]}
          errorMessage={externalErrorMessages[COMPANY_REGISTRATION_ISSUER]}
          inputProps={{
            labelAddition: <InputTooltipInfo inputName={COMPANY_REGISTRATION_ISSUER} t={t} />,
          }}
        />

        <FormInputComponentCol
          t={t}
          inputComponent={InputComponent}
          inputName={COMPANY_VAT_NUMBER}
          key={COMPANY_VAT_NUMBER}
          isValid={!externalErrorMessages[COMPANY_VAT_NUMBER]}
          errorMessage={externalErrorMessages[COMPANY_VAT_NUMBER]}
          inputProps={{
            labelAddition: <InputTooltipInfo inputName={COMPANY_VAT_NUMBER} t={t} />,
          }}
        />

        <FormInputComponentCol
          t={t}
          inputComponent={InputComponent}
          inputName={COMPANY_TAX_NUMBER}
          key={COMPANY_TAX_NUMBER}
          isValid={!externalErrorMessages[COMPANY_TAX_NUMBER]}
          errorMessage={externalErrorMessages[COMPANY_TAX_NUMBER]}
          inputProps={{
            labelAddition: <InputTooltipInfo inputName={COMPANY_TAX_NUMBER} t={t} />,
          }}
        />

        <FormInputComponentCol
          t={t}
          inputComponent={InputComponent}
          inputName={COMPANY_IMPORT_EXPORT_CODE}
          key={COMPANY_IMPORT_EXPORT_CODE}
          isValid={!externalErrorMessages[COMPANY_IMPORT_EXPORT_CODE]}
          errorMessage={externalErrorMessages[COMPANY_IMPORT_EXPORT_CODE]}
          inputProps={{
            labelAddition: <InputTooltipInfo inputName={COMPANY_IMPORT_EXPORT_CODE} t={t} />,
          }}
        />

        <FormInputComponentCol
          t={t}
          inputComponent={InputComponent}
          inputName={COMPANY_CIN_CODE}
          key={COMPANY_CIN_CODE}
          isValid={!externalErrorMessages[COMPANY_CIN_CODE]}
          errorMessage={externalErrorMessages[COMPANY_CIN_CODE]}
          inputProps={{
            labelAddition: <InputTooltipInfo inputName={COMPANY_CIN_CODE} t={t} />,
          }}
        />
      </FormRow>
    </>
  )
}

export default RegistrationNumbersFormContent
